import * as Types from "../actions/actionTypes";

const initialState = {
  nightMode: false,
};

const themeReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.NIGHTMODE_TOGGLE: {
      return {
        ...state,
        nightMode: action.payload,
      };
    }

    default:
      return state;
  }
};

export default themeReducer;
